import Cookies from 'js-cookie'
import config from '../../../config'

const ADMIN_SLIP_API_URL = `${config.apiAdminGateway}/api/v1/admin/slip`
const ADMIN_BAD_QR_API_URL = `${config.apiAdminGateway}/api/v1/admin/badqr`

export const getAllSlipInOrder = async (orderId) => {
  try {
    const response = await fetch(`${ADMIN_SLIP_API_URL}/${orderId}/onprocess`, {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
    })
    const json = await response.json()
    if (response?.status === 200) {
      return json.data
    }
    return []
  } catch (error) {
    console.log('getAllSlipInOrder error ---> ', error)
    return []
  }
}

export const getSlipsByStatus = async (name) => {
  try {
    const response = await fetch(
      `${config.apiAdminGateway}/api/v1/admin/slip/transaction/group?category=coupon&status=${name}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )
    const json = await response.json()
    if (response?.status === 200) {
      return json.data
    }
    return []
  } catch (error) {
    console.error(error)
    return []
  }
}

export const approveBadSlip = async (body) => {
  const response = await fetch(`${ADMIN_BAD_QR_API_URL}/approve`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
    body: JSON.stringify(body),
  })
  const dataJson = await response.json()
  if (response?.status === 200) {
    if (dataJson.code === 0) {
      return { success: true }
    }
    return { success: false, msg: dataJson.desc, code: dataJson.code }
  }
  return { success: false, msg: dataJson.desc, code: dataJson.code }
}

export const rejectBadSlip = async (body) => {
  try {
    const response = await fetch(`${ADMIN_BAD_QR_API_URL}/reject`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
      body: JSON.stringify(body),
    })
    const dataJson = await response.json()
    if (response?.status === 200) {
      if (dataJson.code === 0) {
        return { success: true }
      }
      return { success: false, msg: dataJson.desc }
    }
    return { success: false, msg: dataJson.desc }
  } catch (error) {
    console.log('rejectedBadSlip error ---> ', error)
    return { success: false, msg: error }
  }
}

export const readQRCode = async (slipId, body) => {
  body.slipId = slipId
  const response = await fetch(`${ADMIN_BAD_QR_API_URL}/qrcode`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
    body: JSON.stringify(body),
  })
  const dataJson = await response.json()

  if (response?.status === 200) {
    if (dataJson.code === 0) {
      return { success: true }
    }
    return { success: false, msg: dataJson.desc, code: dataJson.code }
  }
  return { success: false, msg: dataJson.desc, code: dataJson.code }
}

export const readQRCodeAgain = async (slipId, body) => {
  body.slipId = slipId
  const response = await fetch(`${ADMIN_BAD_QR_API_URL}/qrcode/again`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
    body: JSON.stringify(body),
  })
  const dataJson = await response.json()
  if (response?.status === 200) {
    if (dataJson.code === 0) {
      return { success: true }
    }
    return { success: false, msg: dataJson.msg, code: dataJson.code }
  }
  return { success: false, msg: dataJson.msg, code: dataJson.code }
}

export const getRemainingAmount = async (slipId) => {
  try {
    const response = await fetch(`${ADMIN_SLIP_API_URL}/${slipId}/remainingAmount`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
    })
    const dataJson = await response.json()
    if (response?.status === 200) {
      return { remainingAmount: dataJson?.data?.remainingAmount }
    }
    return { remainingAmount: undefined }
  } catch (error) {
    console.error('getRemainingAmount error ---> ', error)
    return { remainingAmount: undefined }
  }
}

export const messagesToCustomer = async (body) => {
  try {
    const response = await fetch(`${ADMIN_BAD_QR_API_URL}/notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
      body: JSON.stringify(body),
    })
    const dataJson = await response.json()
    if (response?.status === 200) {
      return { success: true }
    } else {
      return { success: false, msg: dataJson.msg }
    }
  } catch (error) {
    console.error('messagesToCustomer error ---> ', error)
    return { success: false, msg: error }
  }
}
